<template>
    <div>
		<action-sidebar
			title=""
			:value="true"
			:width="480"
			@close-modal="closeModal"
		>
			<div class="wrapper">
				<h2 class="modal-title"
					:style="`color:${$appColors.primary}`"
				>Tipo de Respuesta</h2>
				<answer-by-tool :templates="answers"></answer-by-tool>
				<div class="modal-btn-container">
					<app-button
						class="close-btn"
						:style="`background-color:${$appColors.error}`"
						text="Cerrar"
						@click="closeModal"
					/>
				</div>
			</div>
		</action-sidebar>
    </div>
</template>
<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appButton from '@/components/shared/app-button';
import answerByTool from '@/components/configuration/tools/answers-by-tool';
import { mapState } from 'vuex';

function created() {
	this.$store.dispatch('answer/loadAnswersByType');
}

function closeModal() {
	this.$router.back();
}

function data() {
	return {
		templates: [
			{
				title: 'Tipo de respuesta 1',
				code: 'CL',
				id: 1,
				answers: [
					{ urlImage: '', name: 'MUY MALO', value: 1, weight: 5 },
					{ urlImage: '', name: 'MALO', value: 2, weight: 5 },
					{ urlImage: '', name: 'BUENO', value: 3, weight: 5 },
					{ urlImage: '', name: 'MUY BUENO', value: 4, weight: 5 },
				],
			},
			{
				title: 'Tipo de Respuesta 2',
				code: 'DO',
				id: 2,
				answers: [
					{ urlImage: '', name: 'FATAL', value: 1, weight: 5 },
					{ urlImage: '', name: 'MUY MALO', value: 2, weight: 5 },
					{ urlImage: '', name: 'MALO', value: 3, weight: 5 },
					{ urlImage: '', name: 'REGULAR', value: 4, weight: 5 },
					{ urlImage: '', name: 'BUENO', value: 5, weight: 5 },
					{ urlImage: '', name: 'MUY BUENO', value: 6, weight: 5 },
					{ urlImage: '', name: 'EXCELENTE', value: 7, weight: 5 },
				],
			},
		],
	};
}

export default {
	name: 'answer-type-selection',
	components: {
		actionSidebar,
		answerByTool,
		appButton,
	},
	computed: {
		...mapState('answer', {
			answers: state => state.answers.answersByType,
		}),
	},
	created,
	data,
	methods: {
		closeModal,
	},
};
</script>
<style lang="scss" scoped>
.wrapper {
	background-color: color(gray-light);
	height: inherit;

	.modal-title {
		border-bottom: 1px solid color(gray-slider);
		font-family: font(bold);
		font-size: size(xlarge);
		margin: 0px 20px 20px;
		padding-bottom: 12px;
		padding-top: 30px;
	}
	.modal-btn-container {
		background-color: white;
		bottom: 0;
		display: flex;
		justify-content: center;
		padding: 20px;
		position: fixed;
		width: 100%;
		
		.close-btn {
			border-radius: 5px;
			color: white;
			padding: 5px 30px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/answer-type-selection.vue